// external scripts
import $ from "jquery";
import debug from "bows";

// flexible layouts
// import Accordion from './layouts/_accordion';

// example of ES2015 modules loading & tree shaking
import {
	emptyLinks,
	externalLinks
} from "./_links";

import breakpoints from "./_breakpoints";

const $window = $(window);
const $document = $(document);
const $body = $("body");
// const log       = debug('site');

class Tci {
	constructor() {
		this.breakpoints = breakpoints;

		$document.ready(() => this.domReady());
		$window.on("load", () => this.windowLoad());
		$window.on("resize", () => this.windowResize());
		$window.on("scroll", () => this.windowScroll());
	}

	domReady() {
		const log = debug("site:domReady");
		if (typeof $.fn.suggest === "function") {
			$(".search-form__field").suggest("?method=autocomplete", {});
		}

		log("dom.ready");

		this.navbarResize();
		this.navbarScroll();
		this.textboxHeightCalculator();
		this.initNavbarNav();
		this.navToTop();
	}

	windowLoad() {
		const log = debug("site:windowLoad");
		log("window.onload");

		$body.imagesLoaded({
			background: true
		}, () => {
			$('.page-loader__svg--wrap').fadeOut();
			$('.page-loader')
				.delay(200)
				.fadeOut('slow');
		});

		// example of ES2015 modules loading & tree shaking
		emptyLinks();
		externalLinks();
	}

	windowResize() {
		this.navbarResize();
		this.textboxHeightCalculator();
	}

	windowScroll() {
		this.navbarScroll();
	}

	initNavbarNav() {
		const navbar = $(".tci-navbar");
		const navbarNav = $(".tci-navbar__nav");

		/* Hamburger Animation and Dropdown */
		$(".hamburger").on("click", function () {
			$(this).toggleClass("hamburger-active");
			navbarNav.slideToggle();
		});

		$(".nav__menu-item--depth0").hover(
			function () {
				if (!navbar.hasClass("mobile-on")) {
					$(this)
						.find(".nav__link:first")
						.addClass("sub-nav-open");
					$(this)
						.find(".nav__menu--depth1")
						.stop(true, true)
						.fadeIn("fast");
				}
			},
			function () {
				if (!navbar.hasClass("mobile-on")) {
					$(this)
						.find(".nav__link:first")
						.removeClass("sub-nav-open");
					$(this)
						.find(".nav__menu--depth1")
						.stop(true, true)
						.delay(100)
						.fadeOut("fast");
				}
			}
		);

		navbarNav.on(
			"click",
			".nav__menu-item--depth0.nav__menu-item--has-submenu > .nav__link",
			e => {
				if (
					navbar.hasClass("mobile-on") ||
					$window.width() < breakpoints.medium
				) {
					e.preventDefault();
					$(e.currentTarget)
						.toggleClass("subnav-opened")
						.parent()
						.find(".nav__menu--depth1")
						.slideToggle();
				}
			}
		);
	}

	navbarResize() {
		// Mobile On - on resize
		if ($window.width() <= breakpoints.medium) {
			$(".tci-navbar").addClass("mobile-on");
		} else if ($window.width() > breakpoints.medium) {
			$(".tci-navbar").removeClass("mobile-on");
		}
	}

	navbarScroll() {
		// Navbar narrow on scroll from top
		let top = $(window).scrollTop();

		if(top > 100) {
			$('.tci-navbar').addClass('navbar-narrow');
		} else {
			$('.tci-navbar').removeClass('navbar-narrow');
		}
	}

	navToTop() {
		let arrowBtn = '<span class="btn btn-sm" style="position: fixed;right: 50px;bottom: 50px;"><i class="fa fa-arrow-up" style="margin-right: 5px;"></i> Back to Top</span>';
		$('.nav--to-top').html(arrowBtn);
		$('.nav--to-top').show();
	};

	/* ---------------------------------------------
	 Slider Textbox Calculate on Resize
	 --------------------------------------------- */
	textboxHeightCalculator() {
		const slides = Array.from(document.querySelectorAll(".carousel__container"));
		slides.forEach(element => {
			const textbox = element.querySelector(".carousel__text");
			const polygon = element.querySelector(".polygon");
			const textboxWidth = textbox.offsetHeight;
			const textboxHeight = textbox.offsetWidth;
			const windowDiff = (window.innerWidth - 1200) / 2;
			if (windowDiff >= 0) {
				polygon.style.width = `${textboxWidth + textboxHeight + windowDiff}px`;
			} else {
				polygon.style.width = `${textboxWidth + textboxHeight}px`;
			}
		});
	}
}

export default Tci;
